// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RXwAg","label":"styles_label__3nZ_3"};